import PopOver, { IPopOverProps } from "~/ui/popover";

export default class ContextMenu extends PopOver {
	constructor(props: Partial<IPopOverProps> & Pick<IPopOverProps, "anchor" | "content">) {
		super(props);

		this.popOver.classList.add("ui-contextmenu");
	}
}
